import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDeskOffice2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconDeskOffice2"><Path fillRule="evenodd" clipRule="evenodd" d="M15 3H5V10H9V11H3V21H5V13H12V21H21V11H11V10H15V3ZM14 15V13H19V15H14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDeskOffice2;
